<button *ngIf="isLoggedIn" class="mat-button"  [ngClass]="isMenuItem ? 'login-logout-sidenav-menu' : 'login-logout-sidenav-button'">
    <div class="menu-row" fxLayout="row" fxLayoutAlign=" center" (click)="clickHandler()">
        <div *ngIf="isLoggedIn" 
            [ngClass]="isMenuItem ? 'sidenav-logout-button-icon logout-menu-item-icon' : 'sidenav-logout-icon'"></div>
        <div *ngIf="isMenuItem && isExpanded" class="navigation-label">{{label}}</div>
    </div>
</button>
